import React from "react";
import BuildingRegistrationExternalApp from "./Functionality/BuildingRegistrationExternalApp";
import ContainerValidation from "../../Dashboard/Visitor/External/Components/ContainerValidation";
import HeaderValidation from "../../Dashboard/Visitor/External/Components/HeaderValidation";
import {IconLogoIEntryComplete} from "../../../components/buttons/IconButtons";
import BodyValidation from "../../Dashboard/Visitor/External/Components/BodyValidation";
import CustomCard from "../../../components/CustomCard";
import StatusCard from "../../Dashboard/Visitor/External/StatusCard";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: FullStack
 */
const BuildingRegistrationExternal = () => {

    const {
        buildingId,
        userId,
        visitorStatus,
        loading,
        handleStartRegistration,
    } = BuildingRegistrationExternalApp();

    return (
        <ContainerValidation>
            <HeaderValidation
                showBtnBack={false}
                headerCenter={<IconLogoIEntryComplete className={'icon-color-primary-800'} height={30} />}
            />
            <BodyValidation
                showBtnNext={false}
                showBtnPrev={false}
                showLogoFooter={false}
                className="identity-invitation-body"
                classWith="content-center-w-800px gap-2"
            >
                <div className="w-100 px-0 d-flex flex-column flex-md-row gap-2">
                    <CustomCard classes="col-12 mb-64px overflow-hidden" classCard="card-border-8px border-0 p-10px" classContent="p-0">
                        <StatusCard
                            classContent={"px-0 py-2 pb-3 overflow-hidden"}
                            content={{
                                ...visitorStatus,
                                HEADER: visitorStatus.HEADER({
                                    buildingId,
                                    userId
                                }),
                                BODY: visitorStatus.BODY({
                                    buildingId,
                                    userId,
                                    loading,
                                    onStartRegistration: handleStartRegistration
                                }),
                            }}
                        />
                    </CustomCard>
                </div>
            </BodyValidation>
        </ContainerValidation>
    )
}

export default BuildingRegistrationExternal
